import React from 'react';

const TnC = () => {
  return (
    <div className="container p-4">
      <h1>Terms and Conditions</h1>
      <p>
        Welcome to our Terms and Conditions page. By using our services, you agree to the following terms and conditions. Please read them carefully.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using our services, you agree to be bound by these terms. If you do not agree, please do not use our services.
      </p>

      <h2>2. Use of Services</h2>
      <p>
        You agree to use our services only for lawful purposes and in accordance with these terms. You are responsible for ensuring that your use of our services complies with all applicable laws and regulations.
      </p>

      <h2>3. Intellectual Property</h2>
      <p>
        All content, trademarks, and logos on this site are the property of their respective owners. You may not use, reproduce, or distribute any content without prior written permission.
      </p>

      <h2>4. Limitation of Liability</h2>
      <p>
        We are not liable for any damages arising from your use of our services. This includes, but is not limited to, direct, indirect, incidental, or consequential damages.
      </p>

      <h2>5. Changes to Terms</h2>
      <p>
        We reserve the right to update these terms at any time. Any changes will be posted on this page, and your continued use of our services constitutes acceptance of the updated terms.
      </p>

      <h2>6. Contact Us</h2>
      <p>
        If you have any questions about these terms, please contact us at support@platoo.com.
      </p>
    </div>
  );
};

export default TnC;